import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@types-lib';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';

export class MfaOtpAuthEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  post(mfaOtpAuthRequest: Auth.MfaOtpAuthRequest) {
    return this.httpClient
      .post<Auth.MfaOtpAuthResponse>(`${this.env.constants.serverless_tracking_api_url}mfa/verify`, mfaOtpAuthRequest, { withCredentials: true })
  }
}
